import { useNavigate } from "react-router-dom";
import { StatCard, SectionTitle, StatusBadge } from "@/components/common";

export function DashHeader({ kicker, title, sub }) {
  return (
    <div>
      <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">{kicker}</p>
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight uppercase">{title}</h1>
      {sub && <p className="text-sm text-muted-foreground mt-1">{sub}</p>}
    </div>
  );
}

export function Tiles({ items }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
      {items.map(([label, value, tone, sub, testid]) => (
        <StatCard key={label} label={label} value={value} tone={tone || "default"} sub={sub} testid={testid || `tile-${label.toLowerCase().replace(/\W+/g, "-")}`} />
      ))}
    </div>
  );
}

export function OrderList({ title, rows, empty, testid, render }) {
  const navigate = useNavigate();
  return (
    <div className="bg-card border border-border rounded-lg p-4" data-testid={testid}>
      <SectionTitle>{title}</SectionTitle>
      {rows.length === 0 ? <p className="text-sm text-muted-foreground">{empty}</p> : (
        <ul className="divide-y divide-border/60">
          {rows.map((r, i) => (
            <li key={r.shipment_id || r.task_id || r.bill_no || i} className="py-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm cursor-pointer hover:bg-accent/40 rounded px-2"
              onClick={() => r.bill_no && navigate(`/orders/${r.bill_no}`)} data-testid={`${testid}-row-${i}`}>
              {render(r)}
            </li>))}
        </ul>)}
    </div>
  );
}

export function MyTasks({ tasks }) {
  const navigate = useNavigate();
  return (
    <div className="bg-card border border-border rounded-lg p-4" data-testid="dash-my-tasks">
      <SectionTitle right={<button className="text-xs underline text-primary" onClick={() => navigate("/tasks")} data-testid="dash-open-tasks">Open Tasks</button>}>My Open Tasks ({tasks.length})</SectionTitle>
      {tasks.length === 0 ? <p className="text-sm text-signal-green">Nothing pending on you right now.</p> : (
        <ul className="space-y-1">
          {tasks.slice(0, 8).map((t) => (
            <li key={t.task_id} className="flex items-center gap-3 text-sm">
              <span className="metric text-primary">{t.task_id}</span>
              <span className="uppercase font-heading">{t.type.replace(/_/g, " ")}</span>
              <StatusBadge status={t.status} />
              {t.bill_no && <span className="metric text-muted-foreground">{t.bill_no}</span>}
            </li>))}
        </ul>)}
    </div>
  );
}
